import React from 'react';

export default function LessonDataGrid(props) {
  const { data, height = 'auto' } = props;

  return (
    <div
      className="round-dg-wrapper"
      style={{ height: height }}
    >
      <table className="round-dg round-dg--light">
        <thead className="round-dg__header">
          <tr className="round-dg__row">
            <th className="round-dg__cell-header">Nome da aula</th>
            <th
              className="round-dg__cell-header last-cell"
              style={{ width: 110 }}
            >
              Matéria
            </th>
          </tr>
        </thead>

        <tbody className="round-dg__body">
          {data?.map((item, key) => (
            <tr
              className="round-dg__row"
              key={key}
            >
              <td className="round-dg__cell-header round-dg__cell-header--sm round-dg__cell-header--row">
                <span
                  className="u-text-truncate"
                  title={item.name}
                >
                  {item.name}
                </span>
              </td>
              <td className="round-dg__cell round-dg__cell--sm last-cell">
                <span
                  className="badge badge--tiny badge--primary"
                  title={item.taxonomies[0]}
                >
                  {item.taxonomies[0]}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
